import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { LoisirsAtna } from '../components/loisirs/LoisirsAtna';
import { ReadinessCard } from '../components/loisirs/ReadinessCard';
import { ForYou } from '../components/loisirs/ForYou';
import { MyActivities } from '../components/loisirs/MyActivities';
import { CardAccess } from '../components/loisirs/CardAccess';
import { BookingServices } from '../components/loisirs/BookingServices';
import { RegistrationFlow } from '../components/loisirs/RegistrationFlow';
import type { Activity } from '../data/loisirs';
export function MesLoisirs() {
  const [registering, setRegistering] = useState<Activity | null>(null);
  return <main className="bg-white" data-id="element-2120" data-mp="1fzigctyyig7u">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2121" data-mp="1fy7beqtrz2f5">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2122" data-mp="2cj7l3hvdzyps">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2123" data-mp="27pwn868jysa0">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2124" data-mp="2b270zmn2vkjf" />
          <span aria-current="page" data-id="element-2125" data-mp="2fye314ccsbw3">My Recreation</span>
        </nav>

        <header className="mt-4" data-id="element-2126" data-mp="21at0pcnaygp8">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2127" data-mp="219rh2js80lvw">My Recreation</h1>
          <p className="mt-2 max-w-2xl text-[17px] text-slate-600" data-id="element-2128" data-mp="2671cqh67dts6">
            Find, book and get into Town programs, simply.
          </p>
        </header>

        <div className="mt-8" data-id="element-2129" data-mp="1x9h8r0gyhjdv">
          <LoisirsAtna onChip={() => undefined} data-id="element-2130" data-mp="1x9qzwrdqlwl5" />
        </div>

        <div className="mt-8" data-id="element-2131" data-mp="1ic8enz09q1ig">
          <ReadinessCard data-id="element-2132" data-mp="1iczzcesbuety" />
        </div>

        <ForYou onRegister={setRegistering} data-id="element-2133" data-mp="1na0ah441a7rx" />
        <MyActivities data-id="element-2134" data-mp="1nas1e1morhbv" />
        <CardAccess data-id="element-2135" data-mp="1nc37i83lt165" />
        <BookingServices data-id="element-2136" data-mp="3cpg4tddatoxr" />
      </div>

      <RegistrationFlow activity={registering} onClose={() => setRegistering(null)} data-id="element-2137" data-mp="3cqhq0ao13rt7" />
    </main>;
}